import { isVerticalType, forAxisTicks } from './util';
import * as transform from './transform';
import { YEAR_MILLISECONDS } from './axes-common';
import { MONTHS, APOSTROPHE } from '../data/constants';
import * as element from '../util/element';

export default function axesPostRenderXAxis(highchart, options, style) {
  const { id, type, print, product, categoriesAreDates } = options;
  if (id === 'print-barrons' && type !== 'bar') {
    updateBarronsTickLabels(highchart, options);
  }
  if (barronsNoBaseline(highchart, options) && type !== 'scatter' && type !== 'bar') {
    updateBarronsTicks(highchart, options);
  }
  if (product === 'wsj' && !print && options.id !== 'video') {
    highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0].setAttribute('style', 'font-variant-numeric: tabular-nums;');
  }
  if (type === 'bar') {
    formatBarChartLabels(highchart, options);
  } else {
    if (categoriesAreDates) {
      updateDateLabels(highchart, options, style);
    } else {
      updateCategoryLabels(highchart, options);
      if (__MARKETWATCH__) {
        if(product === 'marketwatch' && type === 'line') {
          adjustFirstXAxisTick(highchart.axes[0], false, false);
        }
      }
      if (__FINANCIALNEWS__) {
        if(product === 'financialnews' && type === 'line') {
          adjustFirstXAxisTick(highchart.axes[0], false, false);
        }
      }
    }
  }
  updateForMW(highchart, options);
  if (type === 'scatter') {
    const axis = highchart.axes[0];
    setZeroLineToBlack(highchart, options, axis)
  }

  if (options.id === 'video') {
    const axisLine = highchart.axes[0].axisLine.element;
    const d = axisLine.getAttribute('d').split(' ');
    d[1] = '0';
    axisLine.setAttribute('d', d.join(' '));
  }
}

function setZeroLineToBlack(highchart, options, axis) {
  let zeroX;
  
  forAxisTicks(axis, (ticks, i) => {
    const label = ticks.label.textStr;
    if (label === '0') zeroX = i;
  });
  if (zeroX !== undefined) {
    const zeroTickScatter = axis.ticks[zeroX];
    zeroTickScatter.gridLine.element.setAttribute('stroke', options.styles.axes.zeroGridLine.color || '#333');
    const container = highchart.container;
    const xAxisGrid = container.getElementsByClassName('highcharts-yaxis-grid')[0];
    xAxisGrid.appendChild(zeroTickScatter.gridLine.element);
  }
  
}

function updateBarronsTickLabels(highchart, options) {
  const ticks = highchart.xAxis[0].ticks;
  for (let key in ticks) {
    const tick = ticks[key];
    const tickBottom = +tick.mark.d.split(' ')[5];
    tick.label.element.setAttribute('y', tickBottom + 7);
  }
}

function barronsNoBaseline(highchart, options) {
  const ticks = highchart.axes[1].tickPositions;
  return options.product === 'barrons' &&
    (!highchart.axes[1].ticks[0] ||
    ticks.some(tick => tick < 0) && ticks.some(tick => tick >= 0));
}

function updateBarronsTicks(highchart, options) {
  const ticks = highchart.axes[0].ticks;
  for (let key in ticks) {
    const el = ticks[key].mark.element;
    el.setAttribute('stroke', '#e6e6e6');
    if (options.print) el.setAttribute('stroke-width', 0.4);
  }
}

function updateForMW(highchart, options) {
  if (__MARKETWATCH__) {
    if (options.product === 'marketwatch' && options.type === 'line') {
      const xAxisTicks = highchart.xAxis[0].ticks;
      const xAxisTicksAsArr = Object.keys(xAxisTicks);
      const firstTick = xAxisTicksAsArr[0];
      const lastTick = xAxisTicksAsArr[xAxisTicksAsArr.length - 1];
      for (var x in xAxisTicks) {
        const highchartXAxisGrid = highchart.container.getElementsByClassName('highcharts-xaxis-grid')[0];
        const highchartXAxisGridFirstEl = highchartXAxisGrid.firstElementChild.getAttribute('class');
        const highchartXAxisGridLastEl = highchartXAxisGrid.lastElementChild.getAttribute('class');
        const hasFirstAddedVerticalGridline = highchartXAxisGridFirstEl === 'add-vertical-gridline';
        const hasLastAddedVerticalGridline = highchartXAxisGridLastEl === 'add-vertical-gridline';
        const evalBoth = hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline;
        if (evalBoth) {
          if (xAxisTicks[x].label.element.parentElement) {

          } else {
            xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
          }
        } else {
          if (!hasFirstAddedVerticalGridline && !hasLastAddedVerticalGridline) {
            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst || xAxisTicks[x].isLast) {
            } else {
              if (!xAxisTicks[x].isFirst || !xAxisTicks[x].isLast) {
                xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
              }
            }
          }
          if (!hasFirstAddedVerticalGridline && hasLastAddedVerticalGridline) {
            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isFirst) {
            } else {
              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
            }
          }
          if (!hasLastAddedVerticalGridline && hasFirstAddedVerticalGridline) {

            if (xAxisTicks[x].label.element.parentElement || xAxisTicks[x].isLast) {
            } else {
              xAxisTicks[x].gridLine.element.setAttribute('opacity', 0);
            }
          }
        }
      }
    }
  }
}


function formatBarChartLabels(highchart, options) {
  if (!options.allowCategoriesLinebreak) {
    forAxisTicks(highchart.xAxis[0], (tick) => {
      const tspan = tick.label.element.querySelectorAll('tspan');
      if (tspan.length > 1) {
        // Move the top tspan down to center it vertically in its space:
        const labelY = +tick.label.element.getAttribute('y');
        const tspanY = (+tspan[1].getAttribute('dy') / 2) * (tspan.length - 1);
        tick.label.element.setAttribute('y', labelY + tspanY);

        // Replace last 4 characters with an ellipsis (4 instead of 3 to be
        // ensure nothing is cut off at left):
        const textStr = tspan[0].textContent.substr(0,
          tspan[0].textContent.length - 4) + '...';
        tspan[0].innerHTML = textStr;

        // Remove the extra tspans:
        for (let i = 1; i < tspan.length; i++) {
          element.removeChild(tspan[i]);
        }
      }
    });
  }
}


// Remove category ticks and labels that are redudant or overlapping.
function updateCategoryLabels(highchart, options) {
  if (options.removeOverlappingCategories) {
    let maxWidth = 0;
    const ticksShown = [];
    forAxisTicks(highchart.xAxis[0], (tick, index) => {
      if (tick.label.textStr === index) {
        removeTick(tick);
      } else {
        maxWidth = Math.max(maxWidth, tick.labelLength);
        ticksShown.push(tick);
      }
    });
    const maxLabels = Math.floor(highchart.xAxis[0].width / maxWidth) || 0;
    const skip = Math.ceil(ticksShown.length / maxLabels);
    if (skip > 1) {
      let removeNum = 0;
      for (let i = 0; i < ticksShown.length; i++) {
        if (removeNum > 0 && removeNum < skip) {
          removeTick(ticksShown[i]);
        }
        if (++removeNum === skip) {
          removeNum = 0;
        }
      }
    }
  }
}

// Remove date ticks and labels that are redudant or overlapping.
function updateDateLabels(highchart, options, styles) {
  const axis = highchart.axes[0];
  if (options.type === 'column') {
    const categoriesLen = options.categories[0].length;
    if (options.quarterlyResults && categoriesLen > 9) {
      // centerCategoriesBetweenBars(axis, options);
    } else {
      if (axis.tickInterval < YEAR_MILLISECONDS) {
        // TODO: Re-enable this but with long ticks, better rules.
        // centerCategoriesBetweenBars(axis, options);
        // centerLabelsBetweenBars(highchart, options);
      }
    }
  }
  if (options.quarterlyResults && options.series[0].data.length <= 44) {
  //   ensureMultipleLinesForQuarterlyResults(highchart, styles);
    removeOverlappingQuarterlyResults(axis, options, styles);
  } else {
    const skipNum = getDatesSkipNum(axis, styles.MARGIN);
    const startNum = formatDateLabels(axis, options, skipNum);
    removeAmPm(axis, options);
    const isMwOrFn = options.product === 'marketwatch' || options.product === 'financialnews' ? true : false;
    const tickArray = Object.keys(axis.ticks);
    if (options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
      let isAnIntervalOfOne = options.xAxisInterval.split(' ')[0] === '1' && options.xAxisInterval !== '1 week' ? true : false;
      if (isAnIntervalOfOne || options.xAxisInterval === 'auto') {
        removeOverlappingDates(axis, options, skipNum, startNum, styles);
        if (options.xAxisInterval === '1 day') {
          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
        }
      } else {
        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
          addMinorTick(axis, options, styles, highchart);
        }
        if (isMwOrFn) {
          if (options.xAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.xAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && options.type === 'column') {
          if (options.xAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.xAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && !options.showMinorTicks) {
          if (options.xAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.xAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
      }
    }
    
    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== undefined) {
      let isAnIntervalOfOneMob = options.mobileXAxisInterval.split(' ')[0] === '1' && options.mobileXAxisInterval !== '1 week' ? true : false;
      if (isAnIntervalOfOneMob || options.mobileXAxisInterval === 'auto') {
        removeOverlappingDates(axis, options, skipNum, startNum, styles);
        if (options.mobileXAxisInterval === '1 day') {
          styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
        }
      } else {
        if (options.type !== 'column' && !isMwOrFn && options.showMinorTicks) {
          addMinorTick(axis, options, styles, highchart);
        }
        if (isMwOrFn) {
          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && options.type === 'column') {
          if (options.mobileXAxisInterval === '1 week' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.mobileXAxisInterval === '3 months' && options.showMinorTicks) {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
        if (!isMwOrFn && !options.showMinorTicks) {
          if (options.mobileXAxisInterval === '1 week') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, false);
          }
          if (options.mobileXAxisInterval === '3 months') {
            styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, true);
          }
        }
      }
    }
  }
  if (options.fiscalYears && !options.quarterlyResults) {
    addFY(axis);
  }
  replaceApostrophes(axis);
  adjustLastXAxisTick(axis);
  ensureTickSpacing(axis, options, styles);
  if (__MARKETWATCH__) {
    if(options.product === 'marketwatch' && options.type === 'line') {
      adjustFirstXAxisTick(axis, true, false);
    }
    if(options.product === 'marketwatch' && options.type === 'column' && options.quarterlyResults && options.size === 'marketwatch-4u-inset') {
      adjustFirstXAxisTick(axis, false, true);
    }
  }
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews' && options.type === 'line') {
      adjustFirstXAxisTick(axis, true, false);
    }
  }

  if (__WSJ__) {
    if (options.product === 'wsj') {
      if (!options.showMinorTicks) {
        makeTickShorter(axis, options, styles, highchart);
      }
      const xGridTickGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
      const xGridLabelGroup = highchart.container.getElementsByClassName('highcharts-xaxis-labels')[0];
      if (!options.print) {
        if (options.showMinorTicks) {
          xGridLabelGroup.setAttribute('transform', 'translate(0, -0.5)');
        } else {
          xGridLabelGroup.setAttribute('transform', 'translate(0, -2.5)');
        }
      }
      
      if (((xGridTickGroup.children.length - 1) === xGridLabelGroup.children.length) && options.showMinorTicks) {
        if (!options.print) xGridLabelGroup.setAttribute('transform', 'translate(0, -2.5)');
        makeTickShorter(axis, options, styles, highchart);
      }
    }
    
  }
  
}

// Moves ticks to between bars by shifting them to the left by half the space
// between ticks. For use when x-axis date labels are categories and not actual
// dates, such as quarterly data.
function centerCategoriesBetweenBars(axis, options) {
  const tickSpacing = Math.round(getTickSpacing(axis) * 0.5);
  const x = [];
  forAxisTicks(axis, (tick, tickPos, index) => {
    var markD = transform.read(tick.mark.element, 'd');
    x[index] = markD[0][0] - tickSpacing;// + 0.5;
  });
  moveAxisLabels(axis, x);
}

// Move a series tick marks and labels to specific x positions.
function moveAxisLabels(axis, x) {
  forAxisTicks(axis, (tick, key, index) => {
    if (x[index] !== null && x[index] !== undefined) {
      let markD = transform.read(tick.mark.element, 'd');
      markD[0][0] = markD[1][0] = Math.round(x[index]) + 0.5;
      transform.write(tick.mark.element, 'd', markD[0], markD[1]);
      tick.label.element.setAttribute('x', x[index]);
      const tspan = tick.label.element.querySelectorAll('tspan');
      for (let i = 0; i < tspan.length; i++) {
        tspan[i].setAttribute('x', x[index]);
      }
    }
  });
}

// Get number of x-axis date labels that overlap and therefore must be removed.
function getDatesSkipNum(axis, margin) {
  // At least 2 points are needed if one is to overlap another.
  if (axis.tickPositions.length >= 2) {
    let widest = 0;
    let tickDistance = Math.max(2, getTickSpacing(axis) - margin);
    forAxisTicks(axis, tick => {
      const width = tick.label.element.getBoundingClientRect().right + margin -
        tick.label.element.getBoundingClientRect().left;
      widest = Math.max(widest, width);
    });
    let skipNum = normalizeSkipNumber(Math.ceil(widest / tickDistance));
    let skipLabels = Math.floor(axis.tickPositions.length / skipNum);
    const maxLabels = Math.floor(axis.width / widest);
    while (skipLabels > maxLabels) {
      skipNum = normalizeSkipNumber(Math.ceil(widest / --tickDistance));
      skipLabels = Math.floor(axis.tickPositions.length / skipNum);
    }
    return skipNum;
  }
  return 0;
}

// When overlapping date labels are removed, this returns a number that is more
// normal to skip over: 10 instead of 9 or 5 instead of 3.
function normalizeSkipNumber(skip) {
  if (skip > 2 && skip < 5) {
    return 5;
  } else if (skip > 5 && skip < 10) {
    return 10;
  } else if (skip > 10 && skip < 15) {
    return 15;
  } else if (skip > 15 && skip < 20) {
    return 20;
  } else if (skip > 20 && skip < 25) {
    return 25;
  } else if (skip > 25 && skip < 50) {
    return 50;
  } else if (skip > 50 && skip < 100) {
    return 100;
  }
  return skip;
}

// Returns the distance/space between the first two ticks of an axis.
function getTickSpacing(axis) {
  let spacing = 0;
  if (axis.tickPositions.length > 1) {
    const t1 = axis.ticks[axis.tickPositions[0]];
    const t2 = axis.ticks[axis.tickPositions[1]];
    const d1 = transform.read(t1.mark.element, 'd');
    const d2 = transform.read(t2.mark.element, 'd');
    spacing = d2[0][0] - d1[0][0];
  }
  return spacing;
}

// Format x-axis dates that are not quarterly results nor fiscal years.
function formatDateLabels(axis, options, skipNum) {
  let dateType = null;
  let startNum = 0;
  skipNum = skipNum || 0;

  forAxisTicks(axis, (tick, key, index) => {
    const str = tick.label.textStr;

    if (/^(\d{4})\b/.test(str)) {
      dateType = 'year';
    } else if (options.dateTimeLabelFormat === '%e. %b') {
      dateType = 'month-date';
    } else if (options.dateTimeLabelFormat === '%b \'%y') {
      dateType = 'month-year';
    }
    if (skipNum >= 2) {
      if (+str % skipNum === 0) {
        startNum = index;
        return false;
      }
    } else {
      return false;
    }
  });

  if (dateType === 'year') {
    formatYears(axis, startNum);
  } else if (dateType === 'month-year') {
    // This just removes duplicated years; we don't actually want to do this yet.
    // formatMonthYear(axis, startNum);
  } else if (dateType === 'month-date') {
    formatMonthDate(axis, startNum);
  }
  return startNum;
}


// Called from formatXAxisDates().
function formatYears(axis, startNum) {
  let century;
  let tmpCentury;
  let abbrYear;
  let prevStr;
  forAxisTicks(axis, (tick, key, index) => {
    if (index >= startNum) {
      let str = tick.label.textStr + '';
      if (str === prevStr) {
        prevStr = str;
        removeTick(tick);
      } else {
        prevStr = str;
        // Format: 1980 '90 2000 '10
        tmpCentury = str.substr(0, 2);
        if (tmpCentury === century) {
          str = tick.label.textStr = APOSTROPHE + str.substr(2);
          tick.label.element.innerHTML = str;
        } else {
          century = tmpCentury;
        }
        const apostMatch = str.match(/\u2019(\d\d)/);
        if (apostMatch) {
          if (abbrYear === undefined || abbrYear !== apostMatch[1]) {
            abbrYear = apostMatch[1];
          } else if (abbrYear === apostMatch[1]) {
            let apostIndex = str.indexOf(APOSTROPHE);
            if (apostIndex > 0) {
              str = str.substr(0, apostIndex - 1);
              tick.label.element.innerHTML = str;
            }
          }
        }
      }
    }
  });
}

// Called from formatXAxisDates().
function formatMonthYear(axis, startNum) {
  let year = undefined;
  forAxisTicks(axis, tick => {
    if (tick.label.element.parentElement) {
      let label = tick.label.element.innerHTML.split(' ');
      if (label.length === 2) {
        if (label[1] === year) {
          tick.label.textStr = tick.label.element.innerHTML = label[0];
        } else {
          year = label[1];
        }
      }
    }
  });
}

// Called from formatXAxisDates().
function formatMonthDate(axis, startNum) {
  let month = undefined;
  forAxisTicks(axis, tick => {
    if (tick.label.element.parentElement) {
      let label = tick.label.element.innerHTML.split(' ');
      if (label.length === 2 && MONTHS.indexOf(label[0]) !== -1) {
        if (label[0] === month) {
          tick.label.textStr = tick.label.element.innerHTML = label[1];
        } else {
          month = label[0];
        }
      }
    }
  });
}

// Remove superflous am/pm.
function removeAmPm(axis, options) {
  let am;
  forAxisTicks(axis, (tick, key, index) => {
    if (tick.label.element.parentElement) {
      const str = tick.label.textStr + '';
      if (index === 0) {
        if (str.indexOf(' a.m.') !== -1) {
          am = 'a';
        } else if (str.indexOf(' p.m.') !== -1) {
          am = 'p';
        } else if (str === 'noon') {
          am = null;
        } else {
          // Timescale is not hours.
          return;
        }
      } else if (str !== 'noon') {
        let amIndex = str.indexOf(' a.m.');
        const tmpAm = (amIndex !== -1) ? 'a' : 'p';
        if (amIndex === -1) {
          amIndex = str.indexOf(' p.m.');
        }
        if (amIndex !== -1) {
          if (tmpAm === am) {
            tick.label.element.innerHTML = str.substr(0, amIndex);
          } else {
            am = tmpAm;
          }
        }
      }
    }
  });
}

// For overlapping quarterly results, remove labels that do not mention years.
function removeOverlappingQuarterlyResults(axis, options, styles) {
  let tick0 = axis.ticks[axis.tickPositions[0]];
  let rect0 = tick0.label.element.getBoundingClientRect();
  let totalSkips = 0;
  let skips = 1;
  forAxisTicks(axis, (tick, key, index) => {
    if (index > 0) {
      if (rect0 === null && totalSkips > 0) {
        if (tick.label.element.innerHTML) {
          if (skips > 0 && totalSkips > 1 && options.xAxisInterval === 'auto') {
            removeDateTick(tick, options, styles);
          }
          if (++skips >= totalSkips) {
            skips = 0;
          }
        }
      } else {
        if (tick.label.element.innerHTML) {
          var rect = tick.label.element.getBoundingClientRect();
          if (rect0.right + styles.MARGIN >= rect.left && options.xAxisInterval === 'auto') {
            removeDateTick(tick, options, styles);
          } else {
            rect0 = null;
          }
          ++totalSkips;
        }
      }
    }
  });
}

// Removes overlapping datetime labels, accounting for context of datetime
// labels before and after.
function removeOverlappingDates(axis, options, skipNum, startNum, styles) {
  let prevStr = null;
  let label = null;
  const isMY = options.dateTimeLabelFormat === '%b \'%y';
  const isHM = (/^\%H\:\%M/).test(options.dateTimeLabelFormat);
  const axisTickLen = axis.tickPositions.length;
  forAxisTicks(axis, (tick, key, index) => {
    if (axisTickLen >= 2 && skipNum >= 2) {
      if (!(skipNum < 2 || (index - startNum) % skipNum === 0)) {
        removeDateTick(tick, options, styles);
      }
    }
    if (tick.label.element.parentElement) {
      if (isMY) {
        label = tick.label.textStr.split(' ');
        if (label[1] === prevStr) {
          tick.label.element.innerHTML = label[0];
        }
        prevStr = label[1];
      } else if (isHM) {
        label = tick.label.textStr;
        if (label === prevStr) {
          removeDateTick(tick, options, styles);
        }
        prevStr = label;
      }
    }
  });
}

// If fiscalYears, add 'FY' to first label.
function addFY(axis) {
  forAxisTicks(axis, tick => {
    if (tick.label.element.parentElement) {
      tick.label.element.innerHTML = 'FY' + tick.label.textStr;
      return false;
    }
  });
}

// Ensures curly apostrophes render correctly.
function replaceApostrophes(axis) {
  forAxisTicks(axis, tick => {
    const str = tick.label.element.innerHTML + '';
    tick.label.element.innerHTML = str.replace(APOSTROPHE, '&rsquo;');
  });
}

function adjustLastXAxisTick(axis) {
  const tick = axis.ticks[axis.tickPositions[axis.tickPositions.length - 1]];
  const markX = transform.read(tick.mark.element, 'd')[0][0];
  const labelWidth = tick.label.element.getBoundingClientRect().width;
  const offset = (axis.left + axis.width) - (markX + labelWidth / 2);
  tick.label.element.setAttribute('x', markX + Math.min(0, offset));
  tick.label.element.setAttribute('text-anchor', 'middle');
}

function adjustFirstXAxisTick(axis, isDateTime, isColQuarterly) {
  const tick = axis.ticks[axis.tickPositions[0]];
  const markX = transform.read(tick.mark.element, 'd')[0][0];
  const labelWidth = tick.label.element.getBoundingClientRect().width;
  if (labelWidth / 2 > markX && !isColQuarterly) {
    if (isDateTime) {
      tick.label.element.setAttribute('x', labelWidth / 2);
    }
    else {
      tick.label.element.setAttribute('text-anchor', 'left');
    }
  } else {
    tick.label.element.setAttribute('x', markX);
  }
  if (isColQuarterly) {
    const barContainerX = axis.chart.container.getElementsByClassName('highcharts-series-0')[0].firstElementChild.getAttribute('x');
    if (barContainerX <= 0) {
      tick.label.element.setAttribute('text-anchor', 'left');
      tick.label.element.setAttribute('x', 2);
      tick.label.element.children[1].setAttribute('x', 2);
    }
  }
}

// Ensures ticks are spaced adequately apart by removing ticks that are too
// close together.
function ensureTickSpacing(axis, options, styles) {
  const MIN = 4;
  const longs = [];
  let dx;
  forAxisTicks(axis, (tick, key, index) => {
    const markEl = tick.mark.element;
    if (markEl.parentElement &&
        Math.round(markEl.getBoundingClientRect().height) >= styles.MEDIUM_TICK_LENGTH) {
      longs.push(index);
    }
  });
  forAxisTicks(axis, (tick, key, index) => {
    const markEl = tick.mark.element;
    if (markEl.parentElement) {
      const d = transform.read(null, 'd', tick.mark.d);
      if (dx === undefined) {
        dx = d[0][0];
      }
      if (longs.indexOf(index) === -1) {
        if (d[0][0] - dx <= MIN) {
          element.removeChild(markEl);
        } else {
          let n = -1;
          const longFwd = longs.some(longIndex => {
            n = longIndex;
            return longIndex > index;
          });
          if (longFwd) {
            const longTickF = axis.ticks[axis.tickPositions[n]];
            const dlf = transform.read(null, 'd', longTickF.mark.d);
            if (dlf[0][0] - d[0][0] <= MIN) {
              element.removeChild(markEl);
            }
          }
          if (markEl.parentElement) {
            const longBck = longs.some(longIndex => {
              n = longIndex;
              return longIndex < index;
            });
            if (longBck) {
              const longTickB = axis.ticks[axis.tickPositions[n]];
              const dlb = transform.read(null, 'd', longTickB.mark.d);
              if (d[0][0] - dlb[0][0] <= MIN) {
                element.removeChild(markEl);
              }
            }
          }
          dx = d[0][0];
        }
      } else {
        dx = d[0][0];
      }
    }
  });
}

// Removes a date tick and label or replaces it with a short tick depending
// on the context.
function removeDateTick(tick, options, styles) {
  const labelEl = tick.label.element;
  const markEl = tick.mark.element;
  element.removeChild(labelEl);
  if (!options.showMinorTicks) {
    element.removeChild(markEl);
  } 
  if (options.type === 'column') {
    element.removeChild(markEl);
  } else if (Math.round(markEl.getBoundingClientRect().height)
      >= styles.MEDIUM_TICK_LENGTH && options.showMinorTicks) {    
    let d = transform.read(null, 'd', tick.mark.d);
    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
    transform.write(markEl, 'd', d);
  }
}

function addMinorTick(axis, options, styles, highchart) {
  const xAxisGridGroup = axis.chart.axes[0].gridGroup.element;
  if (xAxisGridGroup.children.length > 1) {
    const firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
    const secondInGroupD = transform.read(null, 'd', xAxisGridGroup.children[1].getAttribute('d'));
    let interval;
    let unit;
    if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
      interval = options.mobileXAxisInterval.split(' ')[0];
      unit = options.mobileXAxisInterval.split(' ')[1];
    } 
    if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
      interval = options.xAxisInterval.split(' ')[0];
      unit = options.xAxisInterval.split(' ')[1];
    }
    interval = unit === 'week' ? 7 : interval;
    const diff = (secondInGroupD[0][0] - firstInGroupD[0][0]) / parseInt(interval);
    forAxisTicks(axis, (tick, key, index) => {
      const labelEl = tick.label.element;
      const markEl = tick.mark.element;
      let d = transform.read(null, 'd', tick.mark.d);
      if ((options.dates[0].year % interval !== 0 && options.dates[0].month === 1) || (unit === 'months' || unit === 'week')) {
        let backD = transform.read(null, 'd', tick.mark.d);
        let firstTick;
        if (unit === 'years') {
          firstTick = index === 0 ? parseInt(tick.label.element.children[0].innerHTML) : firstTick;
        }
        if (unit === 'months') {
          let label = tick.label.textStr.split(' ')[0];
          let labelMonthValue = findMonthValue(label);
          firstTick = index === 0 ? labelMonthValue : firstTick;
        }
        if (unit === 'week') {
          firstTick = index === 0 ? parseInt(tick.label.textStr.split(' ')[1]) : firstTick;
        }
        let benchmark;
        if (unit === 'years') {
          benchmark = firstTick - options.dates[0].year;
        }
        if (unit === 'months') {
          benchmark = (firstTick - options.dates[0].month) - 1;
        } 
        if (unit === 'week') {
          benchmark = options.dates[0].date > firstTick ? (firstTick + 30) - options.dates[0].date : firstTick - options.dates[0].date;
        }
        for (let w = 0; w < benchmark; w++) {
          appendToXGridGroup(highchart, diff, styles, backD, false);
        }
      }

      const tickArray = Object.keys(tick.axis.ticks);
      const lastTick = tickArray[tickArray.length - 1];
      const isLastTick = tick.pos === tick.axis.ticks[lastTick].pos ? true : false;
      if (!isLastTick) {
        for (let i = 0; i < interval - 1; i++) {
          appendToXGridGroup(highchart, diff, styles, d, true);
        }
      } else {
        let lastBenchmark;
        if (unit === 'years') {
          lastBenchmark = options.dates[options.dates.length - 1].year - parseInt(tick.label.textCache.split(',')[0]);
        }
        if (unit === 'months') {
          let label = tick.label.textStr.split(' ')[0];
          let labelMonthValue = findMonthValue(label);
          lastBenchmark = options.dates[options.dates.length - 1].month - labelMonthValue;
        }
        if (unit === 'week') {
          lastBenchmark = options.dates[options.dates.length - 1].month.date - parseInt(tick.label.textStr.split(' ')[1]);
        }
        for (let i = 0; i < lastBenchmark; i++) {
          appendToXGridGroup(highchart, diff, styles, d, true);
        }
      }

      const isMonth = unit === 'months' ? true : false;
      if (unit === 'months' || unit === 'week') {
        styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth);
      }
    });
  } 
  // if (xAxisGridGroup.children.length === 1) {
  //   const firstInGroupD = transform.read(null, 'd', xAxisGridGroup.children[0].getAttribute('d'));
  //   let interval;
  //   let unit;
  //   if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
  //     interval = options.mobileXAxisInterval.split(' ')[0];
  //     unit = options.mobileXAxisInterval.split(' ')[1];
  //   } 
  //   if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
  //     interval = options.xAxisInterval.split(' ')[0];
  //     unit = options.xAxisInterval.split(' ')[1];
  //   }
  //   let firstDate;
  //   let lastDate;
  //   if (unit === 'years') {
  //     firstDate = options.dates[0].year;
  //     lastDate = options.dates[options.dates.length - 1].year;
  //   }
  //   if (unit === 'months') {
  //     firstDate = options.dates[0].month;
  //     lastDate = options.dates[options.dates.length - 1].month;
  //   }
  //   if (unit === 'week') {
  //     firstDate = options.dates[0].date;
  //     lastDate = options.dates[options.dates.length - 1].date;
  //   }
  //   const axisTicksKey = Object.keys(axis.ticks);
  //   const xAxisGridLine = highchart.container.getElementsByClassName('highcharts-axis-line')[0];
  //   const xAxisGridLineD = xAxisGridLine.getAttribute('d');
  //   const gridLineD = transform.read(null, 'd', xAxisGridLineD);
  //   const d = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
  //   const secD = transform.read(null, 'd', axis.ticks[axisTicksKey[0]].mark.d);
  //   const isWeekOrYear = unit === 'years' ? axis.ticks[axisTicksKey[0]].label.textStr : axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[1];
  //   let diff = unit !== 'months' ? parseInt(isWeekOrYear) - firstDate : 
  //     findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]) - firstDate;
  //   let diffLast = unit !== 'months' ? lastDate - parseInt(isWeekOrYear) : 
  //     lastDate - findMonthValue(axis.ticks[axisTicksKey[0]].label.textStr.split(' ')[0]);
  //   const diffBetweenFirstDataPoint = Math.round(d[0][0] / diff);
  //   for (let u = 0; u < diff; u++) {
  //     if (d[0][0] - diffBetweenFirstDataPoint >= gridLineD[0][0]) {
  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, d, false);
  //     }
  //   }
  //   for (let y = 0; y < diffLast; y++) {
  //     if (secD[1][0] + diffBetweenFirstDataPoint <= gridLineD[1][0]) {
  //       appendToXGridGroup(highchart, diffBetweenFirstDataPoint, styles, secD, true);
  //     }
  //   }
  // }
}

function appendToXGridGroup(highchart, diff, styles, d, isAfterFirstTick) {
  let newPath = highchart.renderer.path().attr({
    'opacity': 1
  });
  if (isAfterFirstTick) {
    d[0][0] = d[0][0] + diff;
    d[1][0] = d[1][0] + diff;
  } else {
    d[0][0] = d[0][0] - diff;
    d[1][0] = d[1][0] - diff;
  }
  d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
  newPath = transform.write(newPath.element, 'd', d);
  newPath.setAttribute('stroke-width', 1);
  newPath.setAttribute('stroke', '#333333');
  let gridGroup = highchart.container.getElementsByClassName('highcharts-xaxis')[0];
  gridGroup.appendChild(newPath);
}

// Removes a tick label and grid line.
function removeTick(tick) {
  element.removeChild(tick.label.element);
  element.removeChild((tick['gridLine'] || tick['mark']).element);
}

function styleMonthAndDayTicks(axis, options, styles, highchart, tickArray, isMonth) {
  const firstTick = tickArray[0];
  const firstTickVal = isMonth ? axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[1] :
  axis.ticks[firstTick].label.element.children[0].innerHTML.split(' ')[0];
  const landMarkTicks = [firstTickVal];
  forAxisTicks(axis, (tick, key, index) => {
    const tickVal = tick.label.textStr
    const tickValUnit = isMonth ? tickVal.split(' ')[1] : tickVal.split(' ')[0];
    if (landMarkTicks.indexOf(tickValUnit) !== -1 && index !== 0) {
      const arrayVal = isMonth ? 0 : 1;
      if (tick.label.element.children.length > 0) {
        tick.label.element.children[0].innerHTML = tickVal.split(' ')[arrayVal];
      } else {
        tick.label.element.innerHTML = tickVal.split(' ')[arrayVal];
      }
      
    } else {
      landMarkTicks.push(tickValUnit);
    }
  });

}

function findMonthValue(label) {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
  return months.indexOf(label);
}

function makeTickShorter(axis, options, styles, highchart) {
  forAxisTicks(axis, (tick, key, index) => {
    // const labelEl = tick.label.element;
    const markEl = tick.mark.element;
    let d = transform.read(null, 'd', tick.mark.d);
    d[1][1] = d[0][1] + styles.SHORT_TICK_LENGTH;
    transform.write(markEl, 'd', d);
  });
}


// WEBPACK FOOTER //
// ./src/chart/inner/axes-postrender-x-axis.js